import { FC } from "react";
import { PlatformIconKind } from "@/domains/api/types";
import { useResolvePlatformIconData } from "@/components/icons";
import { enumModule } from "@/modules/enum";
import { MDSButton, MDSButtonSlotName, MDSButtonVariant, MDSIcon, MDSIconColor } from "@/mds";

export interface AppCalloutBannerActionButtonViewProps {
  iconKind: PlatformIconKind | null;
  label: string | null;
  buttonVariant?: string | null;
  onClick?: () => void;
}

export const AppCalloutBannerActionButtonView: FC<AppCalloutBannerActionButtonViewProps> = ({
  iconKind,
  label,
  buttonVariant,
  onClick,
}) => {
  const result = useResolvePlatformIconData({ iconKind });
  const parsedMDSIconKind = result?.icon;
  const iconSlotName =
    iconKind === PlatformIconKind.ArrowRight
      ? MDSButtonSlotName.RightIcon
      : MDSButtonSlotName.LeftIcon;
  const resolvedButtonVariant =
    enumModule.findMatchingStringValue(MDSButtonVariant, buttonVariant ?? "") ??
    MDSButtonVariant.ContrastAccent;

  if (!label) return null;

  return (
    <MDSButton onClick={onClick} variant={resolvedButtonVariant}>
      {parsedMDSIconKind && (
        <MDSIcon slot={iconSlotName} kind={parsedMDSIconKind} color={MDSIconColor.Inherit} />
      )}
      {label}
    </MDSButton>
  );
};
